import { Component, Output, EventEmitter, Input, HostListener, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';
import { SearchbarService } from 'src/app/services/searchbar.service';
import { LARGURA_MINIMA_LISTA_E_TABELA } from 'src/app/utils/utils/layout-utils';
import { CarrosselCabecalhoComponent } from '../carrossel-cabecalho/carrossel-cabecalho.component';

@Component({
  standalone: false,
  selector: 'app-controlbar',
  templateUrl: './controlbar.component.html',
  styleUrls: ['./controlbar.component.css']
})
export class ControlBarComponent implements OnInit {

  statusFiltro: boolean;
  layoutAtual = 1;
  toolTipFiltro = 'FECHAR FILTRO';
  isLayoutMobile: boolean;
  isPesquisaSearchbar: boolean;

  @Output()
  abrirFiltroEmitter = new EventEmitter<boolean>();
  @Output()
  ordenacaoEmitter = new EventEmitter<string>();
  @Input()
  ordenacaoInput: string;
  constructor(
    private configService: ConfigService,
    private searchbarService: SearchbarService,
    private carrosselCabecalho: CarrosselCabecalhoComponent
  )
  {
    this.isPesquisaSearchbar = this.searchbarService.getIsPesquisaSearchbar();
    this.carrosselCabecalho.carrosselTabEmitter.subscribe((res)=>{
      this.isPesquisaSearchbar = false;
    });
    this.searchbarService.pesquisaSearchbarEmitter.subscribe((res)=>{
      this.isPesquisaSearchbar = true;
    });
  }
  
  ngOnInit(): void {
    this.isLayoutMobile = window.innerWidth < LARGURA_MINIMA_LISTA_E_TABELA;
    this.layoutAtual = this.configService.getConfig().getLayoutAtual;
  }

  abrirFiltro(statusFiltro: boolean) {
    this.statusFiltro = !statusFiltro;
    this.toolTipFiltro = (this.statusFiltro ? 'ABRIR FILTRO' : 'FECHAR FILTRO');
    this.abrirFiltroEmitter.emit(this.statusFiltro);
  }

  /** Seleciona o layout de exibição: 1 = Lista, 2 = Cards, 3 = Tabela. */
  selecionarLayout(layout: number) {
    this.layoutAtual = layout;
    this.configService.configuraLayoutAtual(layout);
  }

  orderBy(order: string) {
    this.ordenacaoEmitter.emit(order);
  }

  @HostListener('window:resize')
  onresize() {
    this.isLayoutMobile = window.innerWidth < LARGURA_MINIMA_LISTA_E_TABELA;
    this.layoutAtual = this.configService.getConfig().getLayoutAtual;
  }

}
